import { env0Themes, type Env0Theme } from '@env0/ui-theme/env0';

export const TOP_BAR_HEIGHT = '50px';
export const NAVBAR_WIDTH = '220px';
export const NAVBAR_COLLAPSED_WIDTH = '50px';
export const NAVBAR_TRANSITION_DURATION = '300ms';
export const BREADCRUMB_BAR_HEIGHT = '35px';

export type { Env0Theme };

export const darkTheme = env0Themes.dark;

declare module '@emotion/react' {
  export interface Theme extends Env0Theme {}
}

export default env0Themes.light;
